import styled from 'styled-components'
import { Icon } from '@mdi/react'

import { CommonButton, CommonLinkButton } from 'components/Button'
import { Font14, H4, H5 } from 'components/Typography'
import theme from 'theme_'

export const StyledTeamsContainer = styled.div`
  padding: 12px;
  @media ${theme.devices.tablet} {
    padding: 16px 40px;
  }
`

export const StyledTeamH4 = styled(H4)`
  @media ${theme.devices.tablet} {
    font-size: 24px;
    line-height: 32px;
  }
`

export const StyledTeamsHeader = styled.header`
  margin: 0;
  width: 100%;
  @media ${theme.devices.tablet} {
    margin: 16px 0;
  }
`

export const StyledFilters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  @media ${theme.devices.tablet} {
    flex-direction: row;
    height: 40px;
    margin-bottom: 32px;
  }
`

export const TeamSearchDesktopWrapper = styled.div`
  width: 100%;
  display: none;
  @media ${theme.devices.tablet} {
    display: block;
  }
`

export const TeamSearchMobileWrapper = styled.div`
  width: 100%;
  display: block;
  margin: 16px 0;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const StyledAddUserDesktopButton = styled(CommonButton)`
  height: 40px;
  background: transparent;
  display: none;
  :hover {
    opacity: 0.8;
  }
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const StyledAddUserMobileButton = styled(CommonLinkButton)`
  display: flex;
  :hover {
    opacity: 0.8;
  }
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const TeamIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const StyledNoTeam = styled(H5)`
  text-align: center;
  color: ${theme.colors.disabledGrey};
`

export const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
`

export const RowsCount = styled.div`
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: ${theme.colors.white};
  border-radius: 8px;
  ${Font14};
  margin-left: 16px;
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`
